import React from 'react';

import {useGate, useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {BackTo} from 'components/common/BackTo';
import {Stepper} from 'components/ui-kit/Stepper';
import {ROUTE} from 'core/routes';
import {AggregationGate, step$} from 'models/documents/create/aggregation';

import {ContentWrapper} from '../common/styled';

import {AggregationDocumentChildrenCodes} from './childrenCodes';
import {DocumentForm} from './form';
import {AggregationDocumentParentCodes} from './parentCodes';

export const CreateAggregation = () => {
    const {t} = useTranslation();
    const step = useStore(step$);
    useGate(AggregationGate);
    return (
        <>
            <BackTo to={ROUTE.DOCUMENTS_DOCUMENTS}>{t('pages.documents.back')}</BackTo>
            <ContentWrapper>
                <h1>{t('pages.documents.newDocumentAggregation')}</h1>
                <Stepper
                    steps={[
                        {
                            label: t('pages.documents.aggregationSteps.stepOne.label'),
                            helper: t('pages.documents.aggregationSteps.stepOne.helper'),
                            component: <DocumentForm />,
                        },
                        {
                            label: t('pages.documents.aggregationSteps.stepTwo.label'),
                            helper: t('pages.documents.aggregationSteps.stepTwo.helper'),
                            component: <AggregationDocumentParentCodes />,
                        },
                        {
                            label: t('pages.documents.aggregationSteps.stepThree.label'),
                            helper: t('pages.documents.aggregationSteps.stepThree.helper'),
                            component: <AggregationDocumentChildrenCodes />,
                        },
                    ]}
                    activeStep={step}
                />
            </ContentWrapper>
        </>
    );
};
